import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const DownloadInstancesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseDownloads/GetNationalFranchiseDownload/${props.Id}`, method: 'GET', secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseDownloads/UpdateNationalFranchiseDownload/${props.Id}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        if (props && props.franchiseDownloadTypeId){
            await execute({ scope: 'list', url: `FranchiseDownloads/GetNationalFranchiseDownloads?franchiseDownloadTypeId=${props.franchiseDownloadTypeId}`, method: 'GET', secure: true });
        } else {
            await execute({ scope: 'list', url: 'FranchiseDownloads/GetNationalFranchiseDownloads', method: 'GET', secure: true });
        }
    }, [execute]);  

    const listfranchisedownloadtypes = useCallback(async () => {
        await execute({ scope: 'listfranchisedownloadtypes', url: 'FranchiseDownloads/FranchiseDownloadTypes', method: 'GET', secure: true });
    }, [execute]);  

    const value = { selectRecord, listRecords, updateRecord, listfranchisedownloadtypes, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useDownloadInstancesStore = () => React.useContext(Context);
